import axiosFlow from '@/services/axios/axiosFlow'

export default class TipoSolicitacaoService {
  static async get(filaId) {
    const params = new URLSearchParams()

    if (filaId) {
      params.append('FilaId', filaId)
    }

    return axiosFlow.get(`tipos-solicitacoes?${params}`)
  }

  static async getById(tipoSolicitacaoId) {
    return axiosFlow.get(`tipos-solicitacoes/${tipoSolicitacaoId}`)
  }

  static async getTipoSolicitacaoFormulario(tipoSolicitacaoId) {
    return axiosFlow.get(`tipos-solicitacoes/${tipoSolicitacaoId}/formularios`).then(res => res.data.data)
  }

  static async getTiposDeSolicitacoesAssociadosAUmaFila(tipoSolicitacaoId) {
    return axiosFlow.get(`tipos-solicitacoes/${tipoSolicitacaoId}/filas/associadas`).then(res => res.data.data)
  }

  static async getFilasNaoAssociadasAUmTipoDeSolicitacao(tipoSolicitacaoId) {
    return axiosFlow.get(`tipos-solicitacoes/${tipoSolicitacaoId}/filas/nao-associadas`).then(res => res.data.data)
  }

  static async getFormulariosNaoAssociados(tipoSolicitacaoId) {
    return axiosFlow.get(`tipos-solicitacoes/${tipoSolicitacaoId}/formularios/nao-associados`).then(res => res.data.data)
  }

  static async atualizarTipoSolicitacaoFormulario(tipoSolicitacaoId, formularioId, data) {
    return axiosFlow.put(`tipos-solicitacoes/${tipoSolicitacaoId}/formularios/${formularioId}`, data)
  }

  static async criar(body) {
    return axiosFlow.post('tipos-solicitacoes', body)
  }

  static async update(tipoSolicitacaoId, body) {
    return axiosFlow.put(`tipos-solicitacoes/${tipoSolicitacaoId}`, body)
  }

  static async associarFormulario(tipoSolicitacaoId, body) {
    return axiosFlow.post(`tipos-solicitacoes/${tipoSolicitacaoId}/formularios`, body)
  }

  static async confirmarInativacao(tipoSolicitacaoId, body) {
    return axiosFlow.put(`tipos-solicitacoes/${tipoSolicitacaoId}/ativada`, body)
  }

  static async ativarOuInativarTipoSolicitacaoFormulario(tipoSolicitacaoId, formularioId, body) {
    return axiosFlow.put(`tipos-solicitacoes/${tipoSolicitacaoId}/formularios/${formularioId}/ativada`, body)
  }

  static async ativarOuInativarTipoSolicitacaoFila(tipoSolicitacaoId, filaId, body) {
    return axiosFlow.put(`tipos-solicitacoes/${tipoSolicitacaoId}/formularios/${filaId}/ativada`, body)
  }
}
